import clsx from 'clsx'

import Button from 'shared/ui/Button'

import styles from './ClearButton.module.scss'

export const ClearButton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLButtonElement>) => (
  <Button
    size='small'
    variant='tertiaryText'
    {...props}
    className={clsx(styles.clearButton, className)}
  />
)
